define(["jquery", "knockout", "@modules/content/enrollment/pcpToEnrollmentViewModel"], function ($, ko, PcpToEnrollmentFormViewModel) {

    var dataLayerService = require("@modules/services/dataLayerService");

    function displayModal() {
        //$("#guidedEnrollmentOverlay").modal();
        var options = {};
        // new Bootstrap 5 version of modal is instantiated differently than in the past::
        var myModal = new bootstrap.Modal(document.getElementById("guidedEnrollmentOverlay"), options);
        myModal.show();
    }

    if (window.scan && window.scan.enrollment && $("#pcpToEnrollmentContainer").length > 0) {
        var enrollmentValues = window.scan.enrollment;
        var element = document.getElementById("pcpToEnrollmentContainer");
        var model = new PcpToEnrollmentFormViewModel(
            enrollmentValues.zipcode,
            enrollmentValues.plan,
            enrollmentValues.county,
            enrollmentValues.state,
            enrollmentValues.providerid,
            enrollmentValues.providername,
            enrollmentValues.groupname,
            enrollmentValues.groupnumber,
            enrollmentValues.addresssuffix,
            enrollmentValues.year,
            enrollmentValues.planFinderLink,
            window.scan.aepYears,
            enrollmentValues.contextLanguage,
            enrollmentValues.defaultCountyText,
            enrollmentValues.defaultPlanText,
            enrollmentValues.contextOEBrokerDataDocumentId,
            enrollmentValues.isMarketingPlanPeriod
        );

        ko.applyBindings(model, element);

        $("#continueToOnlineEnrollment").on("click", function (e) {
            e.preventDefault();
            if (model.inputIsValid()) {
                var loadingResults = true;
                model
                    .submitPlanFinderResults()
                    .done(function (results) {
                        loadingResults = false;
                        model.isSubmitting(false);
                        if (!results.IsOnlineEnrollmentAvailable) {
                            model.onlineEnrollmentNotAvailable(true);
                        } else {
                            var planName = $("#continueToOnlineEnrollment").data('planname');
                            var dataLayerEvent = {
                                event: "PCPFinder",
                                step_name: "Select Plan",
                                plan_name: planName,
                                step_number: "3"
                            };
                            dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);
                            window.location.href = results.Url + "?source=findmypcp";
                        }
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        loadingResults = false;
                        model.unexpectedError(true);
                        model.isSubmitting(false);
                    });
            } else {
                model.unexpectedError(true);
                model.isSubmitting(false);
            }
        });

    }
});
